import { memo } from "react";
import { IIconsProps } from "./icons.model";

const FinancasIcon = (props: IIconsProps) => {
    return (
        <i id={props.id} className='fa-solid fa-money-check-dollar' style={{ fontSize: props.fontSize, color: props.color }} />
    );
};

export default memo(FinancasIcon);
